import React from 'react';
import css from './internships.module.scss';
import SupplierPortal from "../internships/SupplierPortal/SupplierPortal";
import Payroll from "./Payroll/payroll";
import Lustre from "./lustre/lustre";


function Internships() {
    return (
        <div className={css.container} id='internships'>
            <h1>Internships</h1>
            <div/>
            <div className={css.projects}>
                <SupplierPortal/>
                <Payroll/>
                <Lustre/>
            </div>
        </div>
    );
}

export default Internships;
